import { RESERVATION_OPTIONS } from "config/consts";
import { ISingleService } from "types";

export const getDefaultVisitTypeOption = (service: ISingleService) => {
  const visibleVisitTypes = service.options.filter(
    (option) => option.category === RESERVATION_OPTIONS.VISIT_TYPE && option.publicVisible !== false,
  );

  return visibleVisitTypes.find((option) => option.name === "Osoba dorosła") ?? visibleVisitTypes[0];
};
